// removed by extract-text-webpack-plugin
module.exports = {"mainPage":"Dashboard-mainPage","catalogFooter":"Dashboard-catalogFooter","footLink":"Dashboard-footLink","unpadded":"Dashboard-unpadded"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Dashboard/index.css
// module id = 1708
// module chunks = 0